import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {deepCopyObject} from "../../../helper/helper";
import moment from "moment";
import Datetime from "react-datetime";
import {validateComponent, validateField} from "../../../common/validation";
import NumberFormat from "react-number-format";

class CustomerPriceListItems extends Component {

    constructor(props) {
        super(props);

        this.state = {
            listPrices: this.props.listPrices,
            error:{},
        };

        this.validateClass =  this.validateClass.bind(this);
        this.validateField =  this.validateField.bind(this);
        this.validateMessage =  this.validateMessage.bind(this);
        this.checkDateValidity =  this.checkDateValidity.bind(this);
        this.handleEditDates = this.handleEditDates.bind(this);
        this.validateComponent =   this.validateComponent.bind(this);
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let self=this;
        let result = validateComponent(self);
        this.setState({
            error: result.error
        });
        return result
    }

    checkDateValidity(index,current, name) {
        let listPrices = deepCopyObject(this.state.listPrices);
        let copyCurrent = current.clone();
        if (name === 'startDate') {
            return moment(copyCurrent).isValid;
        }
        if (name === 'finishDate') {
            return copyCurrent.isAfter(listPrices[index].startDate);
        }
    }

    handleEditDates(index, event, type) {
        let listPrices = deepCopyObject(this.state.listPrices);

        if (type === 'startDate') {
            if (!(typeof event === "string")) {
                let startDate = event.format("YYYY-MM-DD");
                let finishDate = event.clone().add(1, 'years').format('YYYY-MM-DD');

                listPrices[index].startDate=startDate;
                listPrices[index].finishDate=finishDate;
                this.setState({listPrices});
            }
        } else {
            if (!(typeof selection === "string")) {
                let finishDate = event.format("YYYY-MM-DD");
                listPrices[index].finishDate=finishDate;
                this.setState({listPrices});
            }
        }

    }


    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.listPrices !== this.props.listPrices)
        {
            this.setState({listPrices : nextProps.listPrices});
        }
    }

    render() {
        const {listPrices} = this.state;
        return (
            <div>
                <div className="col-sm-12" >
                    <div className="tab-content">
                        <div>
                            <div>
                                <table className="" style={{textAlign: 'center', paddingBottom: "5px", width:"100%"}}>
                                    <thead>
                                    <tr style={{backgroundColor: '#ebedf0'}}>
                                        <th width="5%">#</th>
                                        <th width="15%">Alt Limit</th>
                                        <th width="15%">Üst Limit</th>
                                        <th width="15%">Başlangıç Tarihi</th>
                                        <th width="15%">Bitiş Tarihi</th>
                                        {(this.props.name!=="customerCntFactor")&&<th width="15%">Fiyat</th>}
                                        {(this.props.name!=="customerCntFactor")&&<th width="10%">Birim Fiyat</th>}
                                        <th width="10%">Hakediş Oranı</th>
                                        <th width="10%">İşlem</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {listPrices && listPrices.map((item, index) =>
                                        <tr key={index}>
                                            <td data-label={"#"}>{(index + 1).toString()}</td>
                                            <td data-label={"Alt Limit"}>{<div
                                                className={"form-group" + this.validateClass("lowerLimit_" + index)}>
                                                <NumberFormat id={'lowerLimit_' + index}
                                                              value={item.lowerLimit}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={0}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              placeholder="Alt Limit Giriniz"
                                                              maxLength="10"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.props.onChange({
                                                                  value: e.value,
                                                                  name: "lowerLimit"
                                                              }, index,this.props.name)}
                                                              onBlur={() => this.validateField({
                                                                  target: {
                                                                      id: "lowerLimit_" + index,
                                                                      dataset: {
                                                                          'vdata': "required",
                                                                          'vlength': "1,10"
                                                                      },
                                                                      value: item.lowerLimit
                                                                  }
                                                              })}
                                                              ref={'lowerLimit_' + index}
                                                              inputProps={{
                                                                  id: 'lowerLimit_' + index,
                                                                  dataset: {
                                                                      vdata: "required",
                                                                      vlength: "1,10",
                                                                      value: item.lowerLimit
                                                                  }
                                                              }}
                                                              className="form-control"/>
                                                {this.validateMessage("lowerLimit_" + index) !== "" &&
                                                <UncontrolledTooltip placement="right"
                                                                     target={"lowerLimit_" + index} delay={0}>
                                                    {this.validateMessage("lowerLimit_" + index)}
                                                </UncontrolledTooltip>}</div>}</td>

                                            <td data-label={"Üst Limit"}>{<div
                                                className={"form-group" + this.validateClass("upperLimit_" + index)}>
                                                <NumberFormat id={'upperLimit_' + index}
                                                              value={item.upperLimit}
                                                              isNumericString={true}
                                                              allowNegative={false}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={0}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              placeholder="Üst Limit Giriniz"
                                                              maxLength="10"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.props.onChange({
                                                                  value: e.value,
                                                                  name: "upperLimit"
                                                              }, index,this.props.name)}
                                                              onBlur={() => this.validateField({
                                                                  target: {
                                                                      id: "upperLimit_" + index,
                                                                      dataset: {
                                                                          'vdata': "required",
                                                                          'vlength': "1,10"
                                                                      },
                                                                      value: item.upperLimit
                                                                  }
                                                              })}
                                                              ref={'upperLimit_' + index}
                                                              inputProps={{
                                                                  id: 'upperLimit_' + index,
                                                                  dataset: {
                                                                      vdata: "required",
                                                                      vlength: "1,10",
                                                                      value: item.upperLimit
                                                                  }
                                                              }}
                                                              className="form-control"/>
                                                {this.validateMessage("upperLimit_" + index) !== "" &&
                                                <UncontrolledTooltip placement="right"
                                                                     target={"upperLimit_" + index} delay={0}>
                                                    {this.validateMessage("upperLimit_" + index)}
                                                </UncontrolledTooltip>}</div>}</td>

                                            <td data-label={"Başlangıç Tarihi"}>{<div
                                                className={"form-group" + this.validateClass("tStartDate_" + index)}>
                                                <Datetime locale="tr"
                                                          id={"tStartDate_" + index}
                                                          className="datepicker"
                                                          input={true}
                                                          inputProps={{
                                                              id: 'tStartDate_' + index,
                                                              dataset: {
                                                                  vdata: "date",
                                                                  vlength: "1,255",
                                                                  value: item.startDate
                                                              }
                                                          }}
                                                          onBlur={(momentObj) => this.validateField({
                                                              target: {
                                                                  id: 'tStartDate_' + index,
                                                                  dataset: {
                                                                      'vdata': "required",
                                                                      'vlength': "1,255"
                                                                  },
                                                                  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
                                                              }
                                                          })}
                                                          closeOnSelect={true}
                                                          value={item.startDate ? moment(item.startDate).format('DD-MM-YYYY') : null}
                                                          dateFormat="DD-MM-YYYY"
                                                          ref={"tStartDate_" + index}
                                                          isValidDate={(current) => this.checkDateValidity(index, current, 'startDate')}
                                                          timeFormat={false}
                                                          onChange={(e) => this.props.handleEditDates(index, e, 'startDate',this.props.name)}
                                                />
                                                {this.validateMessage("tStartDate_" + index) !== "" &&
                                                <UncontrolledTooltip placement="right"
                                                                     target={"tStartDate_" + index} delay={0}>
                                                    {this.validateMessage("tStartDate_" + +index)}
                                                </UncontrolledTooltip>}
                                            </div>}</td>
                                            <td data-label={"Bitiş Tarihi"}>{<div
                                                className={"form-group" + this.validateClass("tFinishDate_" + index)}>
                                                <Datetime locale="tr"
                                                          id={"tFinishDate_" + index}
                                                          className="datepicker"
                                                          input={true}
                                                          inputProps={{
                                                              id: 'tFinishDate_' + index,
                                                              dataset: {
                                                                  vdata: "date",
                                                                  vlength: "1,255",
                                                                  value: item.finishDate
                                                              }
                                                          }}
                                                          onBlur={(momentObj) => this.validateField({
                                                              target: {
                                                                  id: "tFinishDate_" + index,
                                                                  dataset: {
                                                                      'vdata': "required",
                                                                      'vlength': "1,255"
                                                                  },
                                                                  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
                                                              }
                                                          })}
                                                          closeOnSelect={true}
                                                          value={item.finishDate ? moment(item.finishDate).format('DD-MM-YYYY') : null}
                                                          dateFormat="DD-MM-YYYY"
                                                          ref={"tFinishDate_" + index}
                                                          isValidDate={(current) => this.checkDateValidity(index, current, 'finishDate')}
                                                          timeFormat={false}
                                                          onChange={(e) => this.props.handleEditDates(index, e, 'finishDate',this.props.name)}
                                                />
                                                {this.validateMessage("tFinishDate_" + index) !== "" &&
                                                <UncontrolledTooltip placement="right"
                                                                     target={"tFinishDate_" + index} delay={0}>
                                                    {this.validateMessage("tFinishDate_" + index)}
                                                </UncontrolledTooltip>}
                                            </div>}</td>
                                            {(this.props.name!=="customerCntFactor")&&<td data-label={"Fiyat"}>
                                                <div
                                                    className={"form-group" + this.validateClass("priceCash_" + index)}>
                                                    <NumberFormat id={'priceCash_' + index}
                                                                  value={item.priceCash}
                                                                  isNumericString={true}
                                                                  allowNegative={false}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={8}
                                                                  maxLength="10"
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  placeholder="Fiyat Giriniz"
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.props.onChangePrice({
                                                                      value: e.value,
                                                                      name: "priceCash"
                                                                  }, index,this.props.name)}
                                                                  onBlur={() => this.validateField({
                                                                      target: {
                                                                          id: "priceCash_" + index,
                                                                          dataset: {
                                                                              'vdata': "required",
                                                                              'vlength': "1,255"
                                                                          },
                                                                          value: item.priceCash
                                                                      }
                                                                  })}
                                                                  ref={'priceCash_' + index}
                                                                  inputProps={{
                                                                      id: 'priceCash_' + index,
                                                                      dataset: {
                                                                          vdata: "required",
                                                                          vlength: "1,255",
                                                                          value: item.priceCash
                                                                      }
                                                                  }}
                                                                  className="form-control"/>
                                                    {this.validateMessage("priceCash_" + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={"priceCash_" + index} delay={0}>
                                                        {this.validateMessage("priceCash_" + index)}
                                                    </UncontrolledTooltip>}</div></td>}
                                            {(this.props.name!=="customerCntFactor")&&<td data-label={"Birim Fiyat"}>
                                                <div
                                                    className={"form-group" + this.validateClass("unitPrice_" + index)}>
                                                    <NumberFormat id={'unitPrice_' + index}
                                                                  value={item.unitPrice}
                                                                  disabled={true}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={4}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  placeholder="Birim Fiyat"
                                                                  maxLength="10"
                                                                  className="form-control"/></div></td>}
                                            <td data-label={"Hakediş Oranı"}>{<div
                                                className={"form-group" + this.validateClass("factor_" + index)}>
                                                <NumberFormat id={'factor_' + index}
                                                              value={item.factor}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={2}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              placeholder="Oran Giriniz"
                                                              maxLength="4"
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.props.onChange({
                                                                  value: e.value,
                                                                  name: "factor"
                                                              }, index,this.props.name)}
                                                              onBlur={() => this.validateField({
                                                                  target: {
                                                                      id: "factor_" + index,
                                                                      dataset: {
                                                                          'vdata': "smallerThanOrEquals",
                                                                          'vlength': "1.00"
                                                                      },
                                                                      value: item.factor
                                                                  }
                                                              })}
                                                              ref={'factor_' + index}
                                                              inputProps={{
                                                                  id: 'factor_' + index,
                                                                  dataset: {
                                                                      vdata: "smallerThanOrEquals",
                                                                      vlength: "1.00",
                                                                      value: item.factor
                                                                  }
                                                              }}
                                                              className="form-control"/>
                                                {this.validateMessage("factor_" + index) !== "" &&
                                                <UncontrolledTooltip placement="right"
                                                                     target={"factor_" + index} delay={0}>
                                                    {this.validateMessage("factor_" + index)}
                                                </UncontrolledTooltip>}</div>}</td>

                                            <td data-label={"İşlemler"}>
                                                <button type="button"
                                                        onClick={() => this.props.handleRemove(index,this.props.name)}
                                                        disabled={(this.props.name!=="customerCntFactor")&&listPrices.length < 2}
                                                        data-toggle="tooltip" data-placement="bottom"
                                                        title="Sil"
                                                        style={{background: 'linear-gradient(#ff3636b8, #ff3636b8)'}}
                                                        rel="tooltip" className="Btn btn-sm btn-icon">
                                                    <i className="fa fa-trash"/>
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                                <button type="button" onClick={()=>this.props.addNewLine(this.props.name)}
                                        disabled={this.props.isLoading}
                                        style={{background:' linear-gradient(rgb(134 193 243), #1085d8)', padding:'9px 45px 9px 20px'}}
                                        className="TekBtn ekle">Satır Ekle
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default CustomerPriceListItems;